/**
 * TGTP Product Quantity Validation
 *
 * 商品詳細ページの quantity selector の入力値と、購入上限
 * (product / variant の purchase_limit) を突き合わせて
 * buy button を動的に disable する。
 *
 * 期待する DOM:
 *   <div class="tgtp-product-buy-button"
 *        data-button-state="available"
 *        data-max-quantity="3"               (商品単位の上限 / 任意)
 *        data-max-variant-quantity="2"       (バリエーション単位の上限 / 任意)
 *        data-cart-qty="0"                   (カート内のこの商品の合計数)
 *        data-variant-cart-qty-map='{"123":0,"456":1}'
 *        data-current-variant-id="123"
 *        data-exceed-label="購入可能点数を超えています">
 *     <button class="tgtp-product-buy-btn" data-original-label="カートに入れる">
 *       <span class="tgtp-product-buy-btn__text">カートに入れる</span>
 *     </button>
 *   </div>
 *
 *   <input class="tgtp-product-quantity__input" type="number" value="1" min="1">
 *
 * 動作方針:
 * - data-button-state が "available" 以外の場合は何もしない
 *   (Liquid 側で既に売切れ／販売停止等で disabled になっている状態を
 *    JS で勝手に上書きしない)。
 * - quantity input の input / change イベントで再評価。
 * - バリエーション変更時には variant-cart-qty-map から該当バリエーションの
 *   カート内数量を引いて再評価。
 * - 超過時: button.disabled = true, label を data-exceed-label に置換。
 * - 復帰時: button.disabled = false, label を data-original-label に戻す。
 */
(function () {
  function init() {
    const section = document.querySelector('.tgtp-main-product');
    if (!section) return;

    const wrapper = section.querySelector('.tgtp-product-buy-button');
    if (!wrapper) return;

    // Liquid 側で既に available 以外（売切れ・販売停止・購入済み等）の場合は
    // JS による上書きをしない。
    if (wrapper.dataset.buttonState !== 'available') return;

    const btn = wrapper.querySelector('.tgtp-product-buy-btn');
    if (!btn) return;

    const labelEl = btn.querySelector('.tgtp-product-buy-btn__text') || btn;
    const input = section.querySelector('.tgtp-product-quantity__input');

    const maxQty = parseIntOrNull(wrapper.dataset.maxQuantity);
    const maxVariantQty = parseIntOrNull(wrapper.dataset.maxVariantQuantity);
    const cartQty = parseInt(wrapper.dataset.cartQty, 10) || 0;
    const exceedLabel = wrapper.dataset.exceedLabel || '購入可能点数を超えています';
    const originalLabel = btn.dataset.originalLabel || labelEl.textContent;

    // 上限がどちらも設定されていない場合はバリデーション不要。
    if (maxQty === null && maxVariantQty === null) return;

    let variantCartQtyMap = {};
    try {
      variantCartQtyMap = JSON.parse(wrapper.dataset.variantCartQtyMap || '{}');
    } catch (e) {
      variantCartQtyMap = {};
    }

    function parseIntOrNull(v) {
      if (v === undefined || v === null || v === '') return null;
      const n = parseInt(v, 10);
      return isNaN(n) ? null : n;
    }

    function currentVariantCartQty() {
      const vid = wrapper.dataset.currentVariantId;
      if (!vid) return 0;
      return parseInt(variantCartQtyMap[vid], 10) || 0;
    }

    function isExceeding(selectedQty) {
      if (maxQty !== null && cartQty + selectedQty > maxQty) return true;
      if (maxVariantQty !== null &&
          currentVariantCartQty() + selectedQty > maxVariantQty) return true;
      return false;
    }

    function evaluate() {
      // 再評価時にも button-state が変わっていれば手を引く。
      if (wrapper.dataset.buttonState !== 'available') return;

      let selectedQty = input ? parseInt(input.value, 10) : 1;
      if (isNaN(selectedQty) || selectedQty < 1) selectedQty = 1;

      if (isExceeding(selectedQty)) {
        btn.disabled = true;
        labelEl.textContent = exceedLabel;
        wrapper.dataset.quantityExceeded = 'true';
      } else {
        // 元のラベルに戻す。Liquid 側で disabled になっていない前提
        // (button-state === 'available') なので enable 可。
        btn.disabled = false;
        labelEl.textContent = originalLabel;
        delete wrapper.dataset.quantityExceeded;
      }
    }

    if (input) {
      input.addEventListener('input', evaluate);
      input.addEventListener('change', evaluate);
    }

    // バリエーション切替で current variant が変わったときに再評価。
    wrapper.addEventListener('tgtp:variant-change', evaluate);

    // 初期評価（quantity=1 のはずだが念のため）。
    evaluate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
